import { Component, OnInit } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser'
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ExpedienteService } from 'src/app/services/expediente/expediente.service';

@Component({
  selector: 'app-consultas',
  templateUrl: './consultas.component.html',
  styleUrls: ['./consultas.component.css'],
})
export class ConsultasComponent implements OnInit {
  public cliente;
  public expedientes_list: any[] = [];
  public caso;
  constructor(
    private _expedienteService: ExpedienteService,
    private _authService: AuthService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.cliente = this._authService.user;
    let caso = this.route.snapshot.paramMap.get('caso');
    if (caso == 'proximos') this.caso = 'proximos';
    else if (caso == 'transito') this.caso = 'proceso';
    else if (caso == 'finalizados') this.caso = 'finalizados';
    console.log('cliente', this.cliente);
    if (!!this.cliente) this.consultar_data();
  }
  consultar_data() {
    /* this._expedienteService
      .buscar_expedientes({ clientes_id: this.cliente.id })
      .subscribe((res: any) => {
        this.expedientes_list = res.lista;
        console.log('obteniendo expedientes', res);
      }); */
    const obj = {
      opcion_filtro: this.caso,
      clientes_id: this.cliente.id,
    };
    this._expedienteService.expedientes_transito(obj).subscribe((res: any) => {
      console.log('obteniendo consulta', res);
      this.expedientes_list = res.lista;
    });
  }
}
